import React from "react";
import Navbar from "../components/Navbar";
import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import Gallery from "../components/Gallery";
import FAQ from "../components/FAQ";
import Registration from "../components/Registration";
import Footer from "../components/Footer";

export default function Landing() {
  return (
    <div className="bg-[#FDFBF7]" data-testid="landing-page">
      <Navbar />
      <Hero />
      <About />
      <Services />
      <Gallery />
      <FAQ />
      <Registration />
      <Footer />
    </div>
  );
}
